<app-top-navigation></app-top-navigation>
<div class="notification-container">
  <app-notification-list></app-notification-list>
</div>
<div>
  <router-outlet></router-outlet>
</div>
